import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AutorunComponent } from '@myshared/autorun.component';
import { Model } from 'src/app/app.model';
import { Subscription } from 'src/app/subscription/subscription.model';
import { SubscriptionService } from 'src/app/subscription/subscription.service';

@Component({
  selector: 'app-create-ticket-v2',
  templateUrl: './create-ticket-v2.component.html',
  standalone: false
})
export class CreateTicketV2Component extends AutorunComponent implements OnInit {
  
  public subscription: Subscription = null;
  public side: Side = 'none';

  constructor(private m: Model,
    private subscriptionService: SubscriptionService,
    private route: ActivatedRoute,
    private router: Router) {
    super();
  }

  ngOnInit(): void {

    const applianceId = this.route.snapshot.paramMap.get('applianceId');
    if (applianceId) {
      this.autorun(() => {
        const subscription = this.m.subscription.subscriptions.find(s => s.appliance_id === applianceId && s.isValid);
        if (subscription && subscription.hasSupport) {
          this.selectSubscription(subscription);
        } else if (subscription && !subscription.hasSupport) {
          this.router.navigate(['/subscriptions', subscription.appliance_id]);
        } else {
          this.side = 'subscriptions';
        }
      });
      this.subscriptionService.refresh(true);
    } else {
      this.side = 'subscriptions'; // no appliance id from the params, show the subscription list
    }
  }

  selectSubscription(subscription: Subscription) {
    this.subscription = subscription;
    this.side = 'ticket';
  }
}

type Side = 'none' | 'subscriptions' | 'ticket';
